export default function trim(string: string | null | undefined) {
  return string?.trim() ?? '';
}
